// import API, { defaultGetLdHeaders } from '@/api';
import API, { defaultHeaders } from '@/api';

const fetchListing = (page = 1, query = null, pagination = true) => {
  // const headers = Object.assign({}, defaultGetLdHeaders);
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;

  let url = `${API}/panel/exam?page=${page}${query ? `&query=${query}` : ''}`;
  if (pagination === false) {
    url = `${API}/panel/exam?pagination=0`;
  }

  return fetch(url, { headers });
};

export default fetchListing;
